import { tesEmployeesListingRoutes } from './features/tes-employees-listing/tes-employees-listing.routes';
import { tesEmployeeDetailsRoutes } from './features/tes-employee-details/tes-employee-details.routes';
export const tesEmployeesRoutes = [
  {
    path: '/tes-employees',
    name: 'tes-employees',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "expenses" */ './TesEmployees.vue'),
    children: [...tesEmployeesListingRoutes, ...tesEmployeeDetailsRoutes]
  }
];
